import { render, staticRenderFns } from "./LaGranja.vue?vue&type=template&id=74a12ee5&scoped=true"
var script = {}
import style0 from "./LaGranja.vue?vue&type=style&index=0&id=74a12ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a12ee5",
  null
  
)

export default component.exports